import React, { Component } from "react";
import moment from "moment";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Input,
  Label,
  Form,
  Button,
} from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../assets/scss/components/CustomDatepicker/index.scss";

import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditor from "@ckeditor/ckeditor5-react";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import { fetchQueryParams } from "../../utils/comman";
import {
  nameValidation,
  numberValidation,
  emailValidation,
} from "../../utils/helperFunction";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import history from "../../history";
import CustomDatepicker from "../CustomDatepicker";
import CustomButton from "../CustomButton";
import CartTitle from "../CartTitle";
import InputText from "../InputText";
import Loader from "../Loader";
import ImageSection from "../ImageSection";

import get from "lodash/get";

const _ = { get };

const eventStatus = ["Upcoming", "Ongoing", "Completed", "Cancelled"];

export default class EventCreation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      eventId: "",
      eventName: "",
      startPoint: "",
      sourceLatitude: "",
      sourceLongitude: "",
      testRide: "",
      hospitality: "",
      eventStartDate: "",
      eventEndDate: "",
      eventDescription: "",
      eventDuration: "",
      startTime: "",
      eventStatus: "Upcoming",
      // endTime:"",
      country: "",
      locality: null,
      state: "",
      city: "",
      advanceBooking: "",
      placeAvailable: "",
      campaignCode: "",
      coordinator: "",
      coordinatorMobile: "",
      coordinatorEmail: "",
      registrationFee: "",
      userMaxCount: "",
      lastDateOfRegistration: "",
      toggleUploadImageSection: false,
      redirectionalUrl: "",
      image: [
        {
          Image: null,
          preview: null,
        },
        {
          Image: null,
          preview: null,
        },
        {
          Image: null,
          preview: null,
        },
        {
          Image: null,
          preview: null,
        },
        {
          Image: null,
          preview: null,
        },
      ],
    };
  }

  setStateToInitial() {
    let state = this.state;
    state.eventId = "";
    state.eventName = "";
    state.startPoint = "";
    state.sourceLatitude = "";
    state.sourceLongitude = "";
    state.testRide = "";
    state.hospitality = "";
    state.eventStartDate = "";
    state.eventEndDate = "";
    state.eventDescription = "";
    state.eventDuration = "";
    state.startTime = "";
    // state.endTime="";
    state.eventStatus = "";
    state.country = "";
    state.locality = null;
    state.state = "";
    state.city = "";
    state.advanceBooking = "";
    state.placeAvailable = "";
    state.campaignCode = "";
    state.coordinator = "";
    state.coordinatorMobile = "";
    state.coordinatorEmail = "";
    state.registrationFee = "";
    state.userMaxCount = "";
    this.setState({ ...state });
  }

  componentDidMount() {
    if (this.props.page !== "create") {
      let queryParams = this.props.query;
      if (queryParams === "") {
        history.push(`/rides/list`);
      } else {
        const params = fetchQueryParams(queryParams);
        this.props.handleFetchSingleEvent(params.id);
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.singleEvent !== null &&
      this.props.singleEvent !== prevProps.singleEvent
    ) {
      if (this.props.page !== "create") {
        this.handleUpdateForm();
      } else {
        this.setStateToInitial();
      }
    }
  }

  handleUpdateForm = () => {
    let state = this.state;
    let { singleEvent } = this.props;
    state.eventId = singleEvent._id;
    state.eventName = singleEvent.eventName;
    state.startPoint = singleEvent.eventLocation;
    state.sourceLatitude = singleEvent.sourcePoint.latitude;
    state.sourceLongitude = singleEvent.sourcePoint.longitude;
    state.testRide = singleEvent.testRide;
    state.hospitality = singleEvent.hospitality;
    state.eventStatus = singleEvent.eventStatus;
    state.eventStartDate = new Date(singleEvent.eventInfo.eventStartDateIso);
    state.eventEndDate = new Date(singleEvent.eventInfo.eventEndDateIso);
    state.lastDateOfRegistration = new Date(singleEvent.registrationCutOffDate);
    state.eventDescription = singleEvent.eventInfo.eventDescription;
    state.eventDuration = singleEvent.eventInfo.durationInDays;
    state.startTime = new Date(singleEvent.eventInfo.startTime);
    // state.endTime = new Date(singleEvent.eventInfo.endTime);

    state.country = singleEvent.eventInfo.country;
    state.locality = singleEvent.locality;
    state.state = singleEvent.eventInfo.state;
    state.city = singleEvent.eventInfo.city;
    state.advanceBooking = singleEvent.advancedBooking;
    state.placeAvailable = singleEvent.placesAvailable;
    state.campaignCode = singleEvent.campaignCode;
    state.coordinator = singleEvent.eventCoordinator.name;
    state.coordinatorMobile = singleEvent.eventCoordinator.mobile;
    state.coordinatorEmail = singleEvent.eventCoordinator.email;
    state.registrationFee =
      singleEvent.registrationFee !== "N/A" ? singleEvent.registrationFee : "";
    state.userMaxCount = singleEvent.allocatedRiderCount;
    state.redirectionalUrl = singleEvent.registrationUrl;
    this.setState({ ...state });
  };

  // handleEmailChange=(e,id)=>{
  //    if(id==="email"){
  //     if (e.target.value.match(nameValidation)) {
  //       this.state[e.target.name] = e.target.value;
  //     }
  //    }
  //    this.setState({ ...this.state });
  // }

  handleChange = (e, id) => {
    let state = this.state;
    let value = e.target.value;
    if (id === "name") {
      if (value.match(nameValidation)) {
        state[e.target.name] = value;
      }
    }
    if (id === "number") {
      if (value.match(numberValidation)) {
        state[e.target.name] = value;
      }
    }
    if (id === "all") {
      state[e.target.name] = value;
    }
    this.setState({ ...state });
  };

  handleDescriptionChange = (e, editor) => {
    const data = editor.getData();
    this.setState({ eventDescription: data });
  };

  handleDescriptionSetData = (editor) => {
    editor.setData(this.state.eventDescription);
  };

  handleGoBack = () => {
    if (this.props.page === "create") {
      history.push("/event/list");
    }
    if (this.props.page === "update") {
      let queryParams = this.props.query;
      const params = fetchQueryParams(queryParams);
      history.push(`/event/list`);
    }
    if (this.props.page === "event-update") {
      let queryParams = this.props.query;
      const params = fetchQueryParams(queryParams);
      history.push(`/event/moderation?status=${params.status}`);
      console.log("params", queryParams, params);
    }
  };

  handleChangeStartingLocation = (startPoint) => {
    this.setState({ startPoint });
  };

  handleSelectGeoAddressForStartPoint = (startPoint) => {
    this.setState({ startPoint: startPoint });
    geocodeByAddress(startPoint)
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => {
        this.setState({
          sourceLatitude: lat,
          sourceLongitude: lng,
        });
      })
      .catch((error) => console.error("Error", error));
  };

  handleTestRidesChange = (e, id) => {
    let state = this.state;
    state.testRide = id;
    this.setState({ ...state });
  };

  handleHospitalityChange = (e, id) => {
    let state = this.state;
    state.hospitality = id;
    this.setState({ ...state });
  };

  handleAdvanceBookingChange = (e, id) => {
    let state = this.state;
    state.advanceBooking = id;
    this.setState({ ...state });
  };

  handleEventDates = (date, id) => {
    let state = this.state;
    if (id === "start") {
      const shouldEndDateReset = moment(date).isSameOrAfter(state.eventEndDate);
      const shouldRegistrationDateReset = moment(date).isSameOrAfter(
        state.lastDateOfRegistration
      );

      if (shouldEndDateReset) {
        state.eventEndDate = date;
      }
      if (shouldRegistrationDateReset) {
        state.lastDateOfRegistration = date;
      }
      state.eventStartDate = date;
      this.setState({ ...state });
    }
    if (id === "end") {
      state.eventEndDate = date;
      this.setState({ ...state });
    }
    if (id === "time") {
      state.startTime = date;
      this.setState({ ...state });
    }
    // if (id === "endtime") {
    //   state.endTime = date;
    //   this.setState({ ...state });
    // }
    if (id === "last") {
      state.lastDateOfRegistration = date;
      this.setState({ ...state });
    }
  };

  handleChangeRideStatus = (e) => {
    let state = this.state;
    state.rideStatus = e.target.value;
    this.setState({ ...state });
  };

  handleCountryChange = (e) => {
    let state = this.state;
    let parsedValue = JSON.parse(e.target.value);
    if (e.target.value !== "Select Country") {
      state.country = parsedValue.country;
      state.countryCode = parsedValue.locality.country;
      state.locality = parsedValue.locality;
      state.state = "";
      state.city = "";
    }
    this.setState({ ...state });
    this.props.handleFetchState(state.countryCode.toUpperCase());
  };

  handleStateChange = (e) => {
    let state = this.state;
    let parsedValue = JSON.parse(e.target.value);
    if (e.target.value !== "Select Country") {
      state.state = parsedValue.name;
      state.city = "";
    }
    this.setState({ ...state });
    let data = {
      countryCode: state.countryCode.toUpperCase(),
      state: state.state,
    };
    this.props.handleFetchCity(data);
  };

  handleCityChange = (e) => {
    let state = this.state;
    let parsedValue = JSON.parse(e.target.value);
    if (e.target.value !== "Select Country") {
      state.city = parsedValue.name;
    }
    this.setState({ ...state });
  };

  handleUploadImageSection = () => {
    let state = this.state;
    state.toggleUploadImageSection = !state.totalRegistrationsReceived;
    this.setState({ ...state });
  };
  changeState = (e) => {
    this.setState({ state: e.target.value });
  };

  changeCity = (e) => {
    this.setState({ city: e.target.value });
  };

  changeFee = (e) => {
    this.setState(
      { registrationFee: e.target.value },
      console.log(e.target.value)
    );
  };

  handleChangeEventStatus = (e) => {
    let state = this.state;
    state.eventStatus = e.target.value;
    console.log("dropdown input", e.target.value);
    this.setState({ ...state });
  };

  handleSubmitForm = (e) => {
    e.preventDefault();
    let { elements } = this.props;
    let state = this.state;
    if (this.props.userProfile.additionalInfo === null)
      return toast.error(
        _.get(
          elements,
          "eventCreateElement.userDataValidationElement",
          "User Data not Found"
        )
      );

    let data = {
      eventId: state.eventId,
      eventName: state.eventName ? state.eventName.trim() : "",
      eventLocation: state.startPoint,
      sourceLatitude: state.sourceLatitude,
      sourceLongitude: state.sourceLongitude,
      eventStartDate: moment(state.eventStartDate).format("YYYY-MM-DD"),
      eventEndDate: moment(state.eventEndDate).format("YYYY-MM-DD"),

      lastDateOfRegistration: moment(state.lastDateOfRegistration).format(
        "YYYY-MM-DD"
      ),
      eventStatus: state.eventStatus,

      description: state.eventDescription,
      advancedBooking: state.advanceBooking,
      hospitality: state.hospitality,
      placesAvailable: state.placeAvailable,
      testRide: state.testRide,
      country: state.country,
      locality: JSON.stringify(state.locality),
      state: state.state,
      city: state.city,
      eventTime: moment(state.startTime).format(),
      // eventEndTime:state.endTime,
      campaignCode: state.campaignCode,
      eventCoordinatorName: state.coordinator ? state.coordinator.trim() : "",
      eventCoordinatorMobile: state.coordinatorMobile,
      registrationFee:
        state.registrationFee !== "" ? state.registrationFee : "N/A",
      eventCoordinatorEmail: state.coordinatorEmail,
      durationInDays: state.eventDuration,
      allocatedRiderCount: state.userMaxCount,
      redirectionalUrl: state.redirectionalUrl,
    };
    console.log(data);
    let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (state.eventName === "")
      return toast.error(
        _.get(
          elements,
          "eventCreateElement.eventNameValidationElement",
          "Enter Event Name"
        )
      );

    if (state.sourceLatitude === "")
      return toast.error(
        _.get(
          elements,
          "eventCreateElement.locationValidationElement",
          "Select Location"
        )
      );

    if (state.startTime === "")
      return toast.error(
        _.get(
          elements,
          "eventCreateElement.startTimeValidationElement",
          "Select Start Time"
        )
      );

    // if (state.endTime === "")
    // return toast.error(
    //   _.get(
    //     elements,
    //     "eventCreateElement.startTimeValidationElement",
    //     "Select End Time"
    //   )
    // );

    if (state.eventStatus === "")
      return toast.error(
        _.get(
          elements,
          "eventCreateElement.eventStatusValidationElement",
          "Select Event Status"
        )
      );

    if (state.eventDuration === "")
      return toast.error(
        _.get(
          elements,
          "eventCreateElement.durationValidationElement",
          "Enter Duration"
        )
      );

    if (state.eventStartDate === "")
      return toast.error(
        _.get(
          elements,
          "eventCreateElement.startDateValidationElement",
          "Select Start Date"
        )
      );

    if (state.eventEndDate === "" || state.eventEndDate === null)
      return toast.error(
        _.get(
          elements,
          "eventCreateElement.endDateValidationElement",
          "Select End Date"
        )
      );

    if (state.testRide === "")
      return toast.error(
        _.get(
          elements,
          "eventCreateElement.testRideValidationElement",
          "Select Test Ride"
        )
      );

    if (state.hospitality === "")
      return toast.error(
        _.get(
          elements,
          "eventCreateElement.hospitalityValidationElement",
          "Select Hospitality"
        )
      );

    if (state.advanceBooking === "")
      return toast.error(
        _.get(
          elements,
          "eventCreateElement.advanceBookingValidationElement",
          "Select Advance Booking"
        )
      );

    if (state.country === "")
      return toast.error(
        _.get(
          elements,
          "eventCreateElement.countryValidationElement",
          "Select Country"
        )
      );

    if (state.state === "")
      return toast.error(
        _.get(
          elements,
          "eventCreateElement.stateValidationElement",
          "Select State"
        )
      );

    if (state.city === "")
      return toast.error(
        _.get(
          elements,
          "eventCreateElement.cityValidationElement",
          "Select City"
        )
      );

    if (
      state.lastDateOfRegistration === "" ||
      state.lastDateOfRegistration === null
    )
      return toast.error(
        _.get(
          elements,
          "eventCreateElement.registrationValidationElement",
          "Select last date of registration"
        )
      );

    if (state.coordinator === "")
      return toast.error(
        _.get(
          elements,
          "eventCreateElement.coordinatorNameValidationElement",
          "Enter Coordinator Name"
        )
      );

    if (state.coordinatorMobile === "")
      return toast.error(
        _.get(
          elements,
          "eventCreateElement.coordinatorMobileValidationElement",
          "Enter Coordinator Mobile"
        )
      );

    if (state.coordinatorEmail === "")
      return toast.error(
        _.get(
          elements,
          "eventCreateElement.coordinatorEmailValidationElement",
          "Enter Coordinator Email"
        )
      );

    // if (emailPattern.test(data.eventCoordinatorEmail) !== true)
    //   return toast.error(
    //     _.get(
    //       elements,
    //       "eventCreateElement.coordinatorValidEmailValidationElement",
    //       "Enter Valid Coordinator Email"
    //     )
    //   );

    if (state.userMaxCount === "")
      return toast.error(
        _.get(
          elements,
          "eventCreateElement.userMaxCountValidationElement",
          "Enter Event Capacity"
        )
      );

    // if (state.redirectionalUrl === "")
    //   return toast.error(
    //     _.get(
    //       elements,
    //       "eventCreateElement.redirectionalUrlValidationElement",
    //       "Enter Redirectional Url"
    //     )
    //   );

    if (this.props.page === "update") return this.props.handleUpdateEvent(data);
    if (this.props.page === "event-update")
      return this.props.handleUpdateEventAdmin(data);

    return this.props.handleCreateEvent(data);
  };

  render() {
    let { elements } = this.props;
    const renderFunc = ({
      getInputProps,
      suggestions,
      getSuggestionItemProps,
      loading,
    }) => (
      <div>
        <Input
          className="input-text"
          {...getInputProps({
            placeholder: _.get(
              elements,
              "rideCreateElement.searchPlacesElement",
              "Search Places ..."
            ),
          })}
        />
        <div className="autocomplete-dropdown-container">
          {loading && <div>Loading...</div>}
          {suggestions.map((suggestion) => {
            const className = suggestion.active
              ? "suggestion-item"
              : "suggestion-item";
            const style = suggestion.active
              ? { backgroundColor: "#fafafa", cursor: "pointer" }
              : { backgroundColor: "#ffffff", cursor: "pointer" };
            return (
              <div
                {...getSuggestionItemProps(suggestion, {
                  className,
                  style,
                })}
              >
                <span>{suggestion.description}</span>
              </div>
            );
          })}
        </div>
      </div>
    );
    return (
      <React.Fragment>
        {this.props.page !== "update" && this.props.page !== "event-update" ? (
          this.props.createEventStatus !== false ? (
            <Loader />
          ) : null
        ) : this.props.updateEventStatus !== false ? (
          <Loader />
        ) : null}
        <div className="hideSearch">
          <Row>
            <Col sm={12}>
              <CartTitle
                title={_.get(
                  elements,
                  "eventCreateElement.headingElement",
                  "Event Application"
                )}
                Name={"Search"}
                customClass={"hidebtn"}
                innerTextClass={"hidetext"}
                iconClass={"hideexcel"}
              />
            </Col>
          </Row>

          <Form onSubmit={this.handleSubmitForm}>
            <Card className="mb-3 EventCreation">
              <CardBody>
                <Row>
                  <Col md="12"></Col>

                  <Col xl={3} lg={3} md={6} sm={6}>
                    <InputText
                      labelName={_.get(
                        elements,
                        "eventCreateElement.eventNameLabelElement",
                        "Event Name"
                      )}
                      inputType={"text"}
                      inputName={"eventName"}
                      InputClass={"inputText"}
                      inputPlaceholder={_.get(
                        elements,
                        "eventCreateElement.eventNamePlaceHolderElement",
                        "Event Name"
                      )}
                      customValue={this.state.eventName}
                      customMaxLength={75}
                      customMinLength={2}
                      customOnChange={(e) => this.handleChange(e, "name")}
                    />
                  </Col>
                  <Col xl={3} lg={3} md={6} sm={6}>
                    <Label className="inputLabel">
                      {_.get(
                        elements,
                        "eventCreateElement.eventLocationLabelElement",
                        "Event Location"
                      )}
                    </Label>
                    <FormGroup className="position-relative">
                      <PlacesAutocomplete
                        value={this.state.startPoint}
                        onChange={(startPoint) =>
                          this.handleChangeStartingLocation(startPoint)
                        }
                        onSelect={(startPoint) =>
                          this.handleSelectGeoAddressForStartPoint(startPoint)
                        }
                      >
                        {renderFunc}
                      </PlacesAutocomplete>
                    </FormGroup>
                  </Col>
                  <Col xl={3} lg={3} md={6} sm={6}>
                    <InputText
                      labelName={_.get(
                        elements,
                        "eventCreateElement.sourceLatLabelElement",
                        "Latitude"
                      )}
                      style={{
                        backgroundColor: "#ced4da",
                      }}
                      inputType={"text"}
                      inputName={"sourceLatitude"}
                      InputClass={"inputText"}
                      disabledType={true}
                      customValue={this.state.sourceLatitude}
                      inputPlaceholder={_.get(
                        elements,
                        "eventCreateElement.sourceLatPlaceHolderElement",
                        "Latitude"
                      )}
                    />
                  </Col>
                  <Col xl={3} lg={3} md={6} sm={6}>
                    <InputText
                      labelName={_.get(
                        elements,
                        "eventCreateElement.sourceLongLabelElement",
                        "Longitude"
                      )}
                      style={{
                        backgroundColor: "#ced4da",
                      }}
                      inputType={"text"}
                      inputName={"sourceLongitude"}
                      disabledType={true}
                      InputClass={"inputText"}
                      customValue={this.state.sourceLongitude}
                      inputPlaceholder={_.get(
                        elements,
                        "eventCreateElement.sourceLongPlaceHolderElement",
                        "Longitude"
                      )}
                    />
                  </Col>
                  <Col xl={3} lg={3} md={6} sm={6} className="mb-3 mb-lg-0">
                    <Label className="inputLabel">
                      {_.get(
                        elements,
                        "eventCreateElement.eventStartTimeLabelElement",
                        "Event Start Time"
                      )}
                    </Label>
                    <FormGroup className="inputWrpper customDatepicker">
                      <DatePicker
                        onChange={(e) => this.handleEventDates(e, "time")}
                        className={"form-control dateSpace"}
                        timeIntervals={15}
                        timeCaption="Time"
                        dateFormat="h:mm aa"
                        placeholderText={_.get(
                          elements,
                          "eventCreateElement.eventStartTimePlaceHolderElement",
                          "Event Start Time"
                        )}
                        selected={this.state.startTime}
                        showTimeSelect
                        showTimeSelectOnly
                      />
                    </FormGroup>
                  </Col>
                  <Col xl={3} lg={3} md={6} sm={6}>
                    <InputText
                      labelName={_.get(
                        elements,
                        "eventCreateElement.eventDurationLabelElement",
                        "Event Duration"
                      )}
                      inputType={"tel"}
                      inputName={"eventDuration"}
                      InputClass={"inputText"}
                      customValue={this.state.eventDuration}
                      inputPlaceholder={_.get(
                        elements,
                        "eventCreateElement.eventDurationPlaceHolderElement",
                        "Event Duration"
                      )}
                      customMaxLength={7}
                      customMinLength={1}
                      customOnChange={(e) => this.handleChange(e, "number")}
                    />
                  </Col>
                  <Col xl={3} lg={3} md={6} sm={6} className="mb-3 mb-lg-0">
                    <Label className="inputLabel">
                      {_.get(
                        elements,
                        "eventCreateElement.eventStartDateLabelElement",
                        "Event Start Date"
                      )}{" "}
                    </Label>
                    <FormGroup>
                      <CustomDatepicker
                        value={this.state.eventStartDate}
                        customPlaceHolder={_.get(
                          elements,
                          "eventCreateElement.eventStartDatePlaceHolderElement",
                          "Event Start Date"
                        )}
                        handleDateChange={(e) =>
                          this.handleEventDates(e, "start")
                        }
                        customShowMonthDropdown={true}
                        customShowYearDropdown={true}
                        customMinDate={new Date()}
                      />
                    </FormGroup>
                  </Col>
                  <Col xl={3} lg={3} md={6} sm={6} className="mb-3 mb-lg-0">
                    <Label className="inputLabel">
                      {_.get(
                        elements,
                        "eventCreateElement.eventEndDateLabelElement",
                        "Event End Date"
                      )}{" "}
                    </Label>
                    <FormGroup>
                      <CustomDatepicker
                        value={this.state.eventEndDate}
                        customPlaceHolder={_.get(
                          elements,
                          "eventCreateElement.eventEndDatePlaceHolderElement",
                          "Event End Date"
                        )}
                        handleDateChange={(e) =>
                          this.handleEventDates(e, "end")
                        }
                        customShowMonthDropdown={true}
                        customShowYearDropdown={true}
                        customMinDate={this.state.eventStartDate}
                      />
                    </FormGroup>
                  </Col>

                  <Col xl={3} lg={3} md={6} sm={6}>
                    <Label className="inputLabel" for="exampleCheckbox">
                      {_.get(
                        elements,
                        "eventCreateElement.testRideElement",
                        "Test Rides"
                      )}
                    </Label>
                    <FormGroup>
                      <div className="defaultbtn customCheck">
                        <Button
                          type="button"
                          className={`btn-outline-dark bg-none checkbtn mr-2 ${
                            this.state.testRide === true ? "btnthemeColor" : ""
                          }`}
                          onClick={(e) => this.handleTestRidesChange(e, true)}
                        >
                          {_.get(
                            elements,
                            "eventCreateElement.yesElement",
                            "Yes"
                          )}
                        </Button>
                        <Button
                          type="button"
                          className={`btn-outline-dark bg-none checkbtn mr-2 ${
                            this.state.testRide === false ? "btnthemeColor" : ""
                          }`}
                          onClick={(e) => this.handleTestRidesChange(e, false)}
                        >
                          {_.get(
                            elements,
                            "eventCreateElement.noElement",
                            "No"
                          )}
                        </Button>
                      </div>
                    </FormGroup>
                  </Col>

                  <Col xl={3} lg={3} md={6} sm={6}>
                    <Label className="inputLabel" for="exampleCheckbox">
                      {_.get(
                        elements,
                        "eventCreateElement.hospitalityElement",
                        "Hospitality"
                      )}
                    </Label>
                    <FormGroup>
                      <div className="defaultbtn customCheck">
                        <Button
                          type="button"
                          className={`btn-outline-dark bg-none checkbtn mr-2 ${
                            this.state.hospitality === true
                              ? "btnthemeColor"
                              : ""
                          }`}
                          onClick={(e) => this.handleHospitalityChange(e, true)}
                        >
                          {_.get(
                            elements,
                            "eventCreateElement.yesElement",
                            "Yes"
                          )}
                        </Button>
                        <Button
                          type="button"
                          className={`btn-outline-dark bg-none checkbtn mr-2 ${
                            this.state.hospitality === false
                              ? "btnthemeColor"
                              : ""
                          }`}
                          onClick={(e) =>
                            this.handleHospitalityChange(e, false)
                          }
                        >
                          {_.get(
                            elements,
                            "eventCreateElement.noElement",
                            "No"
                          )}
                        </Button>
                      </div>
                    </FormGroup>
                  </Col>
                  <Col xl={3} lg={3} md={6} sm={6}>
                    <Label className="inputLabel" for="exampleCheckbox">
                      {_.get(
                        elements,
                        "eventCreateElement.advanceBookingElement",
                        "Advanced Booking"
                      )}{" "}
                    </Label>
                    <FormGroup>
                      <div className="defaultbtn customCheck">
                        <Button
                          type="button"
                          className={`btn-outline-dark bg-none checkbtn mr-2 ${
                            this.state.advanceBooking === true
                              ? "btnthemeColor"
                              : ""
                          }`}
                          onClick={(e) =>
                            this.handleAdvanceBookingChange(e, true)
                          }
                        >
                          {_.get(
                            elements,
                            "eventCreateElement.yesElement",
                            "Yes"
                          )}
                        </Button>
                        <Button
                          type="button"
                          className={`btn-outline-dark bg-none checkbtn mr-2 ${
                            this.state.advanceBooking === false
                              ? "btnthemeColor"
                              : ""
                          }`}
                          onClick={(e) =>
                            this.handleAdvanceBookingChange(e, false)
                          }
                        >
                          {_.get(
                            elements,
                            "eventCreateElement.noElement",
                            "No"
                          )}
                        </Button>
                      </div>
                    </FormGroup>
                  </Col>

                  <Col xl={3} lg={3} md={6} sm={6}>
                    <Label className="inputLabel">
                      {_.get(
                        elements,
                        "eventCreateElement.countryElement",
                        "Country"
                      )}
                    </Label>
                    <FormGroup className="confirmRiderSelect select_options">
                      <Input
                        type="select"
                        name="City"
                        className="w-100 customeSelectBtn"
                        onChange={this.handleCountryChange}
                      >
                        <option selected="true" disabled="disabled">
                          {this.state.country !== ""
                            ? this.state.country
                            : _.get(
                                elements,
                                "userCreationElements.selectCountryElement",
                                "Select Country"
                              )}
                        </option>
                        {this.props.countries
                          .sort((a, b) =>
                            a.name > b.name ? 1 : b.name > a.name ? -1 : 0
                          )
                          .map((item, index) => (
                            <option key={index} value={JSON.stringify(item)}>
                              {item.country}
                            </option>
                          ))}
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-3 mb-lg-0">
                    <Label className="inputLabel">
                      {" "}
                      {_.get(
                        elements,
                        "eventCreateElement.stateLabel",
                        "State*"
                      )}
                    </Label>
                    <input
                      type="text"
                      name="state"
                      placeholder={_.get(
                        elements,
                        "eventCreateElement.statePlaceHolderElement",
                        "Enter State"
                      )}
                      maxlength="100"
                      autoComplete="off"
                      className="form-control"
                      value={this.state.state}
                      onChange={this.changeState}
                    />
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-3 mb-lg-0">
                    <Label className="inputLabel">
                      {" "}
                      {_.get(elements, "eventCreateElement.cityLabel", "City*")}
                    </Label>
                    <input
                      type="text"
                      name="city"
                      placeholder={_.get(
                        elements,
                        "eventCreateElement.cityPlaceHolderElement",
                        "Enter City"
                      )}
                      maxlength="100"
                      autoComplete="off"
                      className="form-control"
                      value={this.state.city}
                      onChange={this.changeCity}
                    />
                  </Col>
                  <Col xl={3} lg={3} md={6} sm={6} className="mb-3 mb-lg-0">
                    <Label className="inputLabel">
                      {_.get(
                        elements,
                        "eventCreateElement.lastDateOfRegLabelElement",
                        "Last Date Of Registration"
                      )}{" "}
                    </Label>
                    <FormGroup>
                      <CustomDatepicker
                        value={this.state.lastDateOfRegistration}
                        customPlaceHolder={_.get(
                          elements,
                          "eventCreateElement.lastDateOfRegPlaceHolderElement",
                          "Last Date Of Registration"
                        )}
                        handleDateChange={(e) =>
                          this.handleEventDates(e, "last")
                        }
                        customShowMonthDropdown={true}
                        customShowYearDropdown={true}
                        customMaxDate={this.state.eventStartDate}
                      />
                    </FormGroup>
                  </Col>

                  <Col xl={3} lg={3} md={6} sm={6}>
                    <InputText
                      labelName={_.get(
                        elements,
                        "eventCreateElement.eventCoordinatorLabelElement",
                        "Event Coordinator Name"
                      )}
                      inputType={"text"}
                      inputName={"coordinator"}
                      InputClass={"inputText"}
                      customValue={this.state.coordinator}
                      inputPlaceholder={_.get(
                        elements,
                        "eventCreateElement.eventCoordinatorPlaceHolderElement",
                        "Event Coordinator Name"
                      )}
                      customMaxLength={20}
                      customOnChange={(e) => this.handleChange(e, "name")}
                    />
                  </Col>

                  <Col xl={3} lg={4} md={6} sm={6}>
                    <Label className="inputLabel">
                      {_.get(
                        elements,
                        "eventCreateElement.eventStatusElement",
                        "Event Status"
                      )}{" "}
                    </Label>
                    <FormGroup className=" confirmRiderSelect select_options">
                      <Input
                        type="select"
                        name="branchType"
                        className="w-100 customeSelectBtn"
                        onChange={this.handleChangeEventStatus}
                        value={this.state.eventStatus}
                      >
                        {eventStatus.map((item, index) => (
                          <option key={index} value={item}>
                            {" "}
                            {item}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>

                  <Col xl={3} lg={3} md={6} sm={6}>
                    <InputText
                      labelName={_.get(
                        elements,
                        "eventCreateElement.eventCoordinatorMobileLabelElement",
                        "Event Coordinator Mobile"
                      )}
                      inputType={"tel"}
                      inputName={"coordinatorMobile"}
                      InputClass={"inputText"}
                      customValue={this.state.coordinatorMobile}
                      inputPlaceholder={_.get(
                        elements,
                        "eventCreateElement.eventCoordinatorMobilePlaceHolderElement",
                        "Event Coordinator Mobile"
                      )}
                      customMaxLength={15}
                      customMinLength={7}
                      customOnChange={(e) => this.handleChange(e, "number")}
                    />
                  </Col>
                  <Col xl={3} lg={3} md={6} sm={6}>
                    <InputText
                      labelName={_.get(
                        elements,
                        "eventCreateElement.eventCoordinatorEmailLabelElement",
                        "Event Coordinator Email"
                      )}
                      inputType={"text"}
                      inputName={"coordinatorEmail"}
                      InputClass={"inputText"}
                      customValue={this.state.coordinatorEmail}
                      inputPlaceholder={_.get(
                        elements,
                        "eventCreateElement.eventCoordinatorEmailPlaceHolderElement",
                        "Event Coordinator Email"
                      )}
                      customOnChange={(e) => this.handleChange(e, "all")}
                    />
                  </Col>

                  <Col xl={3} lg={3} md={6} sm={6}>
                    <InputText
                      labelName={_.get(
                        elements,
                        "eventCreateElement.userMaxCountLabelElement",
                        "Event Capacity"
                      )}
                      inputType={"tel"}
                      inputName={"userMaxCount"}
                      InputClass={"inputText"}
                      customValue={this.state.userMaxCount}
                      inputPlaceholder={_.get(
                        elements,
                        "eventCreateElement.userMaxCountPlaceHolderElement",
                        "Event Capacity"
                      )}
                      customMaxLength={6}
                      customMinLength={1}
                      customOnChange={(e) => this.handleChange(e, "number")}
                    />
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6}>
                    <Label className="inputLabel">
                      {_.get(
                        elements,
                        "eventCreateElement.registrationFeeLabelElement",
                        "Registration Fee"
                      )}
                    </Label>
                    <FormGroup>
                      <input
                        type="text"
                        name="registrationFee"
                        placeholder={_.get(
                          elements,
                          "eventCreateElement.registrationFeePlaceHolderElement",
                          "Registration Fee"
                        )}
                        maxlength="20"
                        autoComplete="off"
                        className="form-control"
                        value={this.state.registrationFee}
                        onChange={this.changeFee}
                      />
                    </FormGroup>
                  </Col>
                  <Col xl={3} lg={3} md={6} sm={6}>
                    <InputText
                      labelName={_.get(
                        elements,
                        "eventCreateElement.redirectionalUrl",
                        "Redirection Url"
                      )}
                      inputType={"text"}
                      inputName={"redirectionalUrl"}
                      InputClass={"inputText"}
                      customValue={this.state.redirectionalUrl}
                      inputPlaceholder={_.get(
                        elements,
                        "eventCreateElement.redirectionalUrlPlaceHolderElement",
                        "Enter Link"
                      )}
                      customOnChange={(e) => this.handleChange(e, "all")}
                    />
                  </Col>
                  <Col xl={6} lg={6} md={6} sm={6}>
                    <Label className="inputLabel" for="--">
                      {_.get(
                        elements,
                        "eventCreateElement.eventDescriptionLabelElement",
                        "Event Description"
                      )}
                    </Label>
                    <FormGroup>
                      <CKEditor
                        editor={ClassicEditor}
                        onInit={(editor) =>
                          this.handleDescriptionSetData(editor)
                        }
                        data={this.state.eventDescription}
                        onChange={(e, editor) =>
                          this.handleDescriptionChange(e, editor)
                        }
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <div className="d-flex justify-content-center justify-content-lg-end position-relative ">
                  <CustomButton
                    customType={"button"}
                    name={_.get(
                      elements,
                      "eventCreateElement.backButtonElement",
                      "Back"
                    )}
                    customClass={"btn-outline-dark bg-none btnthemeColor"}
                    customClick={() => this.handleGoBack()}
                  />
                  <CustomButton
                    customType={"submit"}
                    name={_.get(
                      elements,
                      "eventCreateElement.submitButtonElement",
                      "Submit"
                    )}
                    customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                  />
                </div>
              </CardBody>
            </Card>
          </Form>
          <ImageSection
            value={this.state}
            handleUploadImageSection={this.handleUploadImageSection}
          />
        </div>
      </React.Fragment>
    );
  }
}
